module.exports = __webpack_public_path__ + "img/gazebo-garden.2bae7984.webp";